// app/not-found.js
'use client';

import Link from "next/link";
import { useEffect, useState } from "react";

export default function ComingSoon({ blok }) {
    return (
        <main className="bg-asmPageTopBG bg-cover">
            <div className="px-6 pt-16 lg:pt-32 flex flex-col items-center bg-[url(/coming-soon-bg.svg)] bg-no-repeat bg-center pb-32 lg:pb-64">
                <div className="relative flex flex-col justify-center items-center">
                    <img src="/Logo.svg" className="w-[150px] lg:w-[200px] mb-[26px] lg:mb-[48px]" />
                    <img src="/coming-soon.svg" className="w-[120px] lg:w-[177px] lg:h-[177px]" />
                    <h1 className="font-aileron text-5xl text-center lg:text-[96px] font-bold text-[#5828E0]">Coming Soon</h1>
                </div>
                <div className="font-lato flex flex-col gap-2 mt-6 lg:mt-0 lg:block  lg:text-[32px] font-normal text-[#222222] text-center">
                    <p>We're working hard to bring you something awesome!</p>
                    <p>This page is under construction and will be available shortly.</p>
                </div>
                <Link href="/" className="bg-[#E56717] text-white px-6 py-3 rounded-md hover:bg-[#D76F1F] transition duration-150 mt-[38px]">Go Back to Homepage</Link>
            </div>
        </main>
    );
}
